// frontend/src/components/ExchangePreferenceList.js

import React from 'react';
import ExchangePreferenceRow from './ExchangePreferenceRow';
import { Plus } from 'lucide-react';
import '../styles/ExchangePreferenceList.css';

const ExchangePreferenceList = ({
  value,
  onChange,
  currentAssignments,
  termOptions = [1, 2, 3, 4, 5, 6, 7],
}) => {
  // 行追加時、補完候補を3件（全て null）で固定
  const addRow = () => {
    onChange([
      ...value,
      {
        sourceTerm: termOptions[0],
        targetTerm: termOptions[0],
        candidate: null,
        complementCandidates: [null, null, null],
        accommodation: false,
      },
    ]);
  };

  // 行更新
  const updateRow = (index, newRow) => {
    const newValues = value.map((row, i) => (i === index ? newRow : row));
    onChange(newValues);
  };

  // 行削除
  const removeRow = (index) => {
    const newValues = value.filter((_, i) => i !== index);
    onChange(newValues);
  };

  return (
    <div className="exchange-list-wrapper">
      {value.length === 0 ? (
        <div className="exchange-empty-state">
          <p>交換希望がまだ登録されていません</p>
          <p style={{ fontSize: '0.8125rem', color: '#94a3b8', marginTop: '0.5rem' }}>
            下のボタンから希望を追加してください
          </p>
        </div>
      ) : (
        <table className="exchange-table">
          <thead>
            <tr>
              <th style={{ width: '16%' }}>現行割当</th>
              <th style={{ width: '11%' }}>移動元ターム</th>
              <th style={{ width: '11%' }}>移動先ターム</th>
              <th style={{ width: '18%' }}>希望候補</th>
              <th style={{ width: '22%' }}>補完候補</th>
              <th style={{ width: '10%' }}>宿泊希望</th>
              <th style={{ width: '8%' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {value.map((row, index) => {
              const currentAssignment = currentAssignments[row.sourceTerm];
              return (
                <ExchangePreferenceRow
                  key={index}
                  index={index}
                  value={row}
                  currentAssignment={currentAssignment}
                  onChange={(newRow) => updateRow(index, newRow)}
                  onRemove={() => removeRow(index)}
                  termOptions={termOptions}
                  isFirstRow={index === 0}
                />
              );
            })}
          </tbody>
        </table>
      )}
      <div style={{ padding: '1rem', textAlign: 'center' }}>
        <button onClick={addRow} className="exchange-add-button" data-tour="exchange-add-button">
          <Plus size={18} />
          希望を追加する
        </button>
      </div>
    </div>
  );
};

export default ExchangePreferenceList;
